import styled from 'styled-components';
import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
export const StyledButtonGroup = styled(ButtonGroup)`
  && {
    margin: 10px;
  }
`;
export const StyledButton = styled(Button)`
  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-root {
    margin: 0px 8px 0px 0px;
    height: 24px;
    min-width: 72px;
    border-radius: 16px;
    font-size: 12px;
    font-family: 'OpenSans-Light';
    color: ${props => props.variant === 'contained' ? '#ffffff' : '#005099'};
    background-color: ${props => props.variant === 'contained' ? '#1661A6' : '#fffff'};
    line-height: 14px;
    outline: none;
    /* border: 1px solid rgba(123, 162, 197, 0.7); */
    text-transform: none;
    display: flex;
    font-weight: 200;
    padding: 4px 16px;
  }
  /* &.MuiButton-root:hover {
    background-color: #ffffff;
  } */
`;
export const StyledLabel = styled.p`
  font-size: 13px;
  font-family: 'OpenSans-Regular' !important;
  color: #141414;
  margin: 10px;
`;
export const StyledLabelGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 175px;
`;
export const ContainerGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
`;